import { useEffect, useState } from 'react';

// COMPONENTS
import FormModal from './FormModal';

// TYPES
import { CompetitorGroup } from './types';
import TooltipPopover from 'components/TooltipPopover';

const FORM_ID = 'competitor-group-modal-form';

const DEFAULT_DATA: CompetitorGroup = {
  customer_id: '',
  id: 0,
  group_id: 0,
  group_name: '',
  domains: '',
};

interface CompetitorGroupModalProps {
  data: CompetitorGroup | null;
  customer_id?: string;
  onCancel: () => void;
  onSubmit: (updatedData: CompetitorGroup) => void;
}

// COMP INTEL EDIT GEOLOCATION MODAL (SETTINGS)
function CompetitorGroupModal({
  data,
  customer_id,
  onCancel,
  onSubmit,
}: CompetitorGroupModalProps) {
  const [isError, setIsError] = useState(false);
  const [formState, setFormState] = useState({ ...DEFAULT_DATA });

  useEffect(() => {
    if (data) {
      setFormState({ ...data });
    }
    if (customer_id) {
      setFormState({ ...DEFAULT_DATA, customer_id });
    }
  }, [data, customer_id]);

  const onUpdate = (evt: React.FormEvent) => {
    evt.preventDefault();
    onSubmit(formState);
  };

  const onChange = (evt: React.ChangeEvent<HTMLInputElement>) => {
    const { value, name } = evt.target;
    setFormState((prev) => ({ ...prev, [name]: value }));
  };

  // JSX
  return (
    <FormModal
      header={`${data ? 'Edit' : 'Add'} Competitor Group`}
      formId={FORM_ID}
      onCancel={onCancel}
      isError={isError}
    >
      <form
        onSubmit={onUpdate}
        id={FORM_ID}
        onInvalid={() => {
          setIsError(true);
        }}
      >
        <label className="block text-sm font-medium text-primarygray">
          Group Name*
        </label>
        <input
          type="text"
          className="p-1 mt-1 block w-full border border-gray200 rounded-md shadow-sm"
          name="group_name"
          value={formState.group_name || ''}
          onChange={onChange}
          required
        />
        <label className="text-sm font-medium text-primarygray inline-flex items-center gap-1 relative">
          <TooltipPopover
            type="info"
            content="settings_page.account_management_tab.comp_intel.add_edit_competitor_group.domain"
            className="top-1 left-[65px]"
            side="top"
          >
            Domains*
          </TooltipPopover>
        </label>
        <input
          type="text"
          className="p-1 mt-1 block w-full border border-gray200 rounded-md shadow-sm"
          name="domains"
          value={formState.domains || ''}
          onChange={onChange}
          required
        />
      </form>
    </FormModal>
  );
}

export default CompetitorGroupModal;
